import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/**
 * Pencil component family `ichw4`/`5gYNd`/`Kvhmu`/`ry0h0`/`HliXq`/`mZwig`/`iM3l2`/`ABGQQ`.
 *
 * Wraps the shadcn `<Badge>` primitive with a status → tone map so call
 * sites stay terse: `<StatusBadge label="confirmed" />`. The status
 * tokens come from the design's HSL palette (`--status-bg-confirmed`,
 * etc.). Unknown values fall back to muted grey so a typo never looks
 * broken.
 */

const TONES: Record<string, string> = {
  confirmed: "bg-status-bg-confirmed text-status-confirmed",
  completed: "bg-status-bg-completed text-status-completed",
  pending:   "bg-status-bg-pending   text-status-pending",
  cancelled: "bg-status-bg-cancelled text-status-cancelled",
  canceled:  "bg-status-bg-cancelled text-status-cancelled",
  no_show:   "bg-status-bg-cancelled text-status-cancelled",
  verifying: "bg-status-bg-verifying text-status-verifying",
  paid:      "bg-status-bg-paid      text-status-paid",
  verified:  "bg-status-bg-paid      text-status-paid",
  unpaid:    "bg-muted               text-muted-foreground",
  active:    "bg-status-bg-completed text-status-completed",
  rejected:  "bg-status-bg-cancelled text-status-cancelled",
  draft:     "bg-muted               text-muted-foreground",
  new:       "bg-status-bg-pending   text-status-pending",
  open:      "bg-status-bg-confirmed text-status-confirmed",
  solved:    "bg-status-bg-completed text-status-completed",
};

export function StatusBadge({
  label,
  className,
  withDot = true,
}: {
  label: string;
  className?: string;
  withDot?: boolean;
}) {
  const tone = TONES[label?.toLowerCase()] ?? "bg-muted text-muted-foreground";
  return (
    <Badge
      // Don't apply the default primary fill — our tone classes drive
      // the colors. Outline drops the default bg + adds a transparent
      // border that our tone overrides.
      variant="outline"
      className={cn(
        "border-transparent gap-1.5 px-2 py-0.5 text-xs font-medium",
        tone,
        className,
      )}
    >
      {withDot && <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" />}
      <span className="capitalize">{label?.replace(/_/g, " ")}</span>
    </Badge>
  );
}
